var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.4286C13.8922 27.4286 15.427 25.8937 15.427 24H8.57307C8.57307 25.8937 10.1079 27.4286 12 27.4286ZM23.5388 19.4084C22.5038 18.2963 20.5672 16.6232 20.5672 11.1429C20.5672 6.98036 17.6486 3.64821 13.7133 2.83071V1.71429C13.7133 0.767679 12.9461 0 12 0C11.054 0 10.2868 0.767679 10.2868 1.71429V2.83071C6.35147 3.64821 3.43289 6.98036 3.43289 11.1429C3.43289 16.6232 1.49629 18.2963 0.461287 19.4084C0.139858 19.7539 -0.00264153 20.167 3.70387e-05 20.5714C0.0059299 21.45 0.695394 22.2857 1.71968 22.2857H22.2804C23.3047 22.2857 23.9947 21.45 24 20.5714C24.0027 20.167 23.8602 19.7534 23.5388 19.4084Z",
    fill: "#BDCCD4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInactiveIcon);
export default __webpack_public_path__ + "static/media/NotificationInactiveIcon.71a03dbb33d9bc2edd9074de70f82cf7.svg";
export { ForwardRef as ReactComponent };